import { useMemo, useRef } from 'react'
import { FiArrowRight, FiCheck } from 'react-icons/fi'

import { t } from 'i18next'

import { Button } from '~/components/Buttons'
import Panel from '~/components/Panel'

import { usePanelSteps } from './ContextProvider'

import * as S from './styles'

const Step: React.FC<StepProps> = ({
  children,
  title,
  description,
  valid,
  disabled
}) => {
  const { currentStep, steps, setCurrentStep, nextStep, prevStep, isLastStep } =
    usePanelSteps()

  const stepRef = useRef<HTMLDivElement | null>(null)
  const stepIndex = useMemo(() => {
    return (
      Number(
        stepRef.current
          ?.closest('.panelsteps-step-item')
          ?.getAttribute('data-step')
      ) || 0
    )
  }, [stepRef.current])

  return (
    <div ref={stepRef}>
      <Panel
        open={Number(stepIndex) === currentStep}
        iconLeft={
          <S.StepIndicator valid={valid}>
            {stepIndex + 1}
            {!!valid && (
              <S.ValidCheck>
                <FiCheck />
              </S.ValidCheck>
            )}
          </S.StepIndicator>
        }
        isCollapsible
        title={title}
        description={description}
        disabled={disabled}
        headerSideContent={
          Number(stepIndex) === currentStep && (
            <S.StepIndicatorWrapper>
              {t('rm:objectiveBased.step.current', {
                step: stepIndex + 1,
                total: steps?.length
              })}
            </S.StepIndicatorWrapper>
          )
        }
        onChangeOpen={isOpen => {
          if (isOpen) {
            setCurrentStep(stepIndex)
          } else {
            setCurrentStep(null)
          }
        }}
      >
        {!disabled && children}
        <S.Footer>
          {stepIndex > 0 ? (
            <S.LinkButton type={'button'} onClick={prevStep}>
              {t('rm:back')}
            </S.LinkButton>
          ) : (
            <span></span>
          )}
          {!isLastStep(stepIndex) && (
            <Button
              disabled={!valid}
              onClick={nextStep}
              iconRight={<FiArrowRight />}
              text={t('rm:objectiveBased.step.next')}
            />
          )}
        </S.Footer>
      </Panel>
    </div>
  )
}

Step.displayName = 'PanelSteps.Step'

export default Step
